<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4443 0C15.7095 0 15.9638 0.105467 16.1514 0.292969L21.707 5.84863C21.8945 6.03616 22 6.29047 22 6.55566V18.7773C22 19.6319 21.6609 20.4524 21.0566 21.0566C20.4524 21.6609 19.6319 22 18.7773 22H3.22266C2.36807 22 1.54764 21.6609 0.943359 21.0566C0.339076 20.4524 0 19.6319 0 18.7773V3.22266C0 2.36807 0.339075 1.54764 0.943359 0.943359C1.54764 0.339075 2.36807 0 3.22266 0H15.4443ZM3.22266 2C2.8985 2 2.58761 2.12919 2.3584 2.3584C2.12919 2.58761 2 2.8985 2 3.22266V18.7773C2 19.1015 2.12919 19.4124 2.3584 19.6416C2.58761 19.8708 2.8985 20 3.22266 20H4.44434V12.1113C4.44434 11.5591 4.8921 11.1114 5.44434 11.1113H16.5557C17.1079 11.1114 17.5557 11.5591 17.5557 12.1113V20H18.7773C19.1015 20 19.4124 19.8708 19.6416 19.6416C19.8708 19.4124 20 19.1015 20 18.7773V6.96973L15.0303 2H6.44434V5.55566H14.333C14.8853 5.55566 15.333 6.00338 15.333 6.55566C15.3329 7.1079 14.8853 7.55566 14.333 7.55566H5.44434C4.89214 7.55561 4.44439 7.10786 4.44434 6.55566V2H3.22266ZM6.44434 20H15.5557V13.1113H6.44434V20Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'SaveIconNew',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
